import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { PhWarning } from 'ember-phosphor-icons';

export interface HeldParticipantWarningSignature {
  Element: HTMLDivElement;
}

const HeldParticipantWarning: TOC<HeldParticipantWarningSignature> = <template>
  <div class="flex items-start justify-center" ...attributes>
    <PhWarning @size="24" @weight="fill" class="text-error-400 mr-2 shrink-0 relative top-1" />
    <p class="text-error-400 font-medium">
      {{t "tuition_assistance.program_details.courses.held_participant_warning"}}
    </p>
  </div>
</template>;

export default HeldParticipantWarning;
